import React from 'react'
import {
  CountryFlag,
  getFormattedOrganizationNumber,
  IconMail,
  Modal,
  Text,
} from '@bbl-digital/snorre-v2'
import { getBbl } from 'shared/store/bbl/selectors'
import { useAppSelector } from 'shared/store/store'
import { getActiveClient } from 'shared/store/clients/selectors'

type ContactModalProps = {
  open: boolean
  onClose: () => void
}

const ContactModal: React.FC<ContactModalProps> = ({ open, onClose }) => {
  const { data } = useAppSelector(getBbl)
  const activeClient = useAppSelector(getActiveClient)

  const invoiceAddress = `${activeClient?.invoiceZip} ${activeClient?.invoiceCity}`
  const businessAddress = `${activeClient?.businessZip} ${activeClient?.businessCity}`

  return (
    <Modal open={open} onClose={onClose}>
      <Modal.Header>Fakturaadresse</Modal.Header>
      <div>
        {activeClient && (
          <>
            {activeClient.companyNumber && (
              <>
                <Text className="text-text-primary font-semibold">EHF:</Text>
                <Text>
                  Org.nr:{' '}
                  {getFormattedOrganizationNumber(activeClient.companyNumber)}
                </Text>
              </>
            )}
            {data.settings.emailInvoiceReception && (
              <div className="flex flex-col mt-2">
                <Text className="font-semibold text-text-primary">E-post:</Text>
                <a
                  href={`mailto:${data.settings.emailInvoiceReception}`}
                  target="_blank"
                  className="text-text-primary underline flex items-center gap-1"
                >
                  <IconMail className="size-2" />
                  {data.settings.emailInvoiceReception}
                </a>
              </div>
            )}
            <Text className="text-text-primary font-semibold mt-2">
              Adresse:
            </Text>
            <Text>
              {activeClient.invoiceAddress || activeClient.businessAddress}
            </Text>
            <div className="flex gap-xs">
              <Text>
                {activeClient.invoiceAddress ? invoiceAddress : businessAddress}
              </Text>
              {activeClient.invoiceAddress && (
                <CountryFlag countryCode={activeClient.invoiceCountryCode} />
              )}
            </div>
          </>
        )}
      </div>
    </Modal>
  )
}

export default ContactModal
